// 客户
import req from './req'

// 保存欢迎语
export function batchDistribution (params) {
  return req.post('/members/potential-member-relationship/batch-distribution', params)
}

// 获取标签列表
export function getTagsList (params) {
  return req.get('/tags/list', params)
}

// 标签-创建标签
export function createTags (params) {
  return req.post('/tags/create', params)
}

// 删除标签
export function deleteTags (tagsId, params) {
  return req.post('/tags/delete/' + tagsId, params)
}

// 修改标签
export function updateTags (tagsId, params) {
  return req.post('/tags/update/' + tagsId, params)
}

// 创建子标签
export function createChildrenTags (params) {
  return req.post('/tags/create_children', params)
}

// 获取标签组详情
export function getTagsInfo (tagsId, params) {
  return req.get('/tags/info/' + tagsId, params)
}

// 获取客户详情标签详情
export function getTagsDetail (params) {
  return req.get('/tags/detail_tags_by_unionid', params)
}

// 同步企微标签
export function syncWechatBabel (params) {
  return req.get('/tags/sync_wechat', params)
}

// 批量绑定标签
export function batchTagging (params) {
  return req.post('/tags/batch_tagging', params)
}

// 单个绑定标签
export function tagging (params) {
  return req.post('/tags/tagging', params)
}

// 匹配用户数
export function matched_customers (params) {
  return req.post('/tags/matched_customers', params)
}

// 异步批量打标签
export function asyn_batch_tagging (params) {
  return req.post('/tags/asyn_batch_tagging', params)
}
